import { SessionContextResponse } from '../network/types';
import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';

const SUPPORTED_RETAIL_UNITS = ['my'];

export function setInsiderObject(user: SessionContextResponse) {
  const { retailUnit } = getRetailUnitAndLanguage();

  if (user.userType === 'G' || !SUPPORTED_RETAIL_UNITS.includes(retailUnit)) return;

  if (!user.emailAddress || !user.userId) throw new Error('Email or userId not found');

  globalThis.insider_object = globalThis.insider_object ?? {};

  globalThis.insider_object.user = {
    email: user.emailAddress,
    custom_identifiers: {
      userid: user.userId,
    },
  };
}
